// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"71bea173e6fe87fc1fe8","147":"0330c528f5b88fb17a08","251":"94d9ed8f9a41d1761154","265":"88cbfd9a071139a17262","352":"4764c8571cce9dd08ba1"}[chunkId] + ".js";
};